import React from 'react';
import { Tag, KIND } from 'baseui/tag';

const methodColors = {
  GET: KIND.positive,
  POST: KIND.accent,
  PUT: KIND.warning,
  DELETE: KIND.negative,
  PATCH: KIND.warning
};

export function MethodTag({ method }) {
  return (
    <Tag 
      closeable={false} 
      kind={methodColors[method] || KIND.accent}
      overrides={{
        Text: {
          style: {
            fontFamily: 'monospace',
            fontSize: '14px',
            width: '60px',
            textAlign: 'center',
            marginTop: '0',
            marginRight: '0',
            marginBottom: '0',
            marginLeft: '0'
          }
        },
        Root: {
          style: {
            width: '70px',
            minWidth: '70px',
            paddingTop: '6px',
            paddingRight: '0',
            paddingBottom: '6px',
            paddingLeft: '0',
            flexShrink: 0,
            marginRight: '8px'
          }
        }
      }}
    >
      {method}
    </Tag>
  );
}
